// Configuration constants for ViewMoreTickets

export const API_CONFIG = {
  apiBaseUrl: "https://operations.roadpilot.co.in/public/api",
  apiDBUploadsUrl: "https://operations.roadpilot.co.in/public/",
};

export const UPLOAD_LIMITS = {
  MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
  MAX_IMAGE_SIZE: 5 * 1024 * 1024, // 5MB for images
  COMPRESSION_QUALITY: 0.7, // 70% quality for compression
};

export const ALLOWED_FILE_TYPES = {
  IMAGES: ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'],
  DOCUMENTS: ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt'],
  VIDEOS: ['mp4', 'webm', 'ogg', 'mov', 'avi', 'mkv', 'wmv', 'flv'],
  AUDIO: ['mp3', 'wav', 'ogg', 'aac', 'flac', 'm4a'],
};

export const ERROR_MESSAGES = {
  FILE_TOO_LARGE: "File size exceeds 10MB limit",
  INVALID_FILE_TYPE: "File type not allowed",
  UPLOAD_FAILED: "Failed to upload file",
  NETWORK_ERROR: "Network error occurred",
  VALIDATION_ERROR: "Please fill in all required fields",
};

export const SUCCESS_MESSAGES = {
  REPLY_SENT: "Reply sent successfully",
  TICKET_CLOSED: "Ticket closed successfully",
  TICKET_REOPENED: "Ticket reopened successfully",
};

export const ERROR_EXPIRY_MS = 300000; // 5 minutes
